import { Component } from '@angular/core';
import {
  FooterStyle,
  MenuStyle,
  TenantConfigService,
} from 'src/app/shared/services/tenant-config.service';

@Component({
  selector: 'app-authorized-container',
  templateUrl: './authorized-container.component.html',
  styleUrls: ['./authorized-container.component.scss'],
})
export class AuthorizedContainerComponent {
  menuStyle: MenuStyle;
  menuStyles = MenuStyle;
  footerStyles = FooterStyle;
  footerStyle: FooterStyle = FooterStyle.DETAILED;
  constructor(private tenantConfigService: TenantConfigService) {
    this.menuStyle = this.tenantConfigService.tenant.menuStyle;
    this.footerStyle = this.tenantConfigService.tenant.footerStyle;
  }
}
